import React from 'react';
import './index.css';
import util from "../../util/tools";
import Header from "../common/Header";
import ActiveCore from "./activeCore"
import commonTools from "../../../common/util/util";
const backImg = require('../../../common/images/arrow_l.png')

export default class ActiveForFirstDayForYear extends React.Component {
    //元旦节活动
    constructor() {
        super();
        this.state = {
            userInfo:{},
            curTitle: "来“鼠”钱，好运到！",
            time:{}, //时间
            rules:[], //规则
            date:{}, //活动
            ruleIsShow: false,//规则弹窗
            resultIsShow: false, //结果弹窗
            resultIsShowBox: false,//结果弹窗box
            isStart: false,
            activeProcess1:{}, //8888活动进度
            activeProcess2:{}, //18888活动进度
            redeemCode: [], // 兑换码列表
            winningCheck: [], // 中奖名单
            timeRule: {rule:[]}
        };
    }
    handleBindBack=()=>{
        this.setState({
            ruleIsShow: false
        })
        this.modalClose();
    }
    handleResultBindBack=()=>{
        this.modalClose();
        this.setState({
            resultIsShow: false,
            resultIsShowBox: false
        },()=>{
            // setTimeout(()=>{
            //     this.setState({
            //         resultIsShowBox: false
            //     })
            // },1000)
        })
    }
    // 打开规则
    handleOpenRule(){
        this.modalOpen();
        this.setState({
            ruleIsShow: true
        },()=>{
            // document.body.addEventListener('touchend',this.handleBindBack)
        });
    }
    // 关闭规则
    handleCloseRule(){
        this.modalClose();
        this.setState({
            ruleIsShow: false
        },()=>{
            // document.body.removeEventListener('touchend',this.handleBindBack)
        });
    }
    //打开我的获奖结果
    handleOpenResult(){
        this.modalOpen();
        this.getRedeemCode(); // 兑奖码
        this.getWinningCheck(); // 获取中奖名单
        this.setState({
            resultIsShow: true,
            resultIsShowBox: true
        },()=>{
            // document.body.addEventListener('touchend',this.handleResultBindBack)
        })
    }
    //关闭我的获奖结果
    handleCloseResult(){
        this.modalClose();
        this.setState({
            resultIsShow: false
        },()=>{
            // document.body.removeEventListener('touchend',this.handleResultBindBack)
            setTimeout(()=>{
                this.setState({
                    resultIsShowBox: false
                })
            },100)
        })
    }
    getWinningCheck = () => {
        // 获取中奖名单
        util.ajax({
            url: "/zh/treasure/rewardinfo",
            isUser: true,
            isWechatId: true,
            data:{

            },
            callback: res => {
                if (res.result.status.code == 0) {
                    this.setState({
                        winningCheck:  res.result.data
                    })
                }
            }
        });
    };
    filterInfo(data){
        let str = '';
     if(data.length){
         if(data[0].is_award&&data[1].is_award){//都中
             str = '恭喜您获得8888金币和18888金币，奖励请到个人账户中查看'
         }
         if(data[0].is_award&&!data[1].is_award){//8888
             str = '恭喜您获得8888金币，奖励请到个人账户中查看'
         }
         if(!data[0].is_award&&data[1].is_award){//18888
             str = '恭喜您获得18888金币，奖励请到个人账户中查看'
         }
         if(!data[0].is_award&&!data[1].is_award){//未中
             str = '很遗憾您未中奖';
         }
     }
     return str
    }
    // 时间和规则
    getTimeRule(){
        util.ajax({
            url: "/zh/treasure/rule",
            data:{

            },
            callback: res => {
                if (res.result.status.code == 0) {
                    this.setState({
                        timeRule:  res.result.data
                    })
                }
            }
        });
    }
    componentDidMount() {
        this.getTimeRule();
        // this.getActiveData(1);
        // this.getActiveData(2);
        this.getRedeemCode(); // 兑奖码
        this.getWinningCheck(); // 获取中奖名单
        document.title = this.state.curTitle;
        this.getData()
        this.getUserInfo()
        this.fromPositionCount()
    }

    fromPositionCount = () => {
        //来源打点 以及进入打点
        let from = commonTools.searchPar().from
        if(from){
            this.positionCount(from)
        }
        this.positionCount(4)
    }

    getData = () => {
        //获取时间、规则、活动进度。
        this.getTime();
        this.getRule();
        this.getActiveDataAll();
    }

    getTime = () => {
        console.log(11,this.props.match.params.source);
        //获取时间
        // util.ajax({
        //     url: "/zh/active/lists",
        //     data:{
        //
        //     },
        //     callback: res => {
        //         if (res.result.status.code == 0) {
        //
        //         }
        //     }
        // });
    }

    getRule = () => {
        // 获取规则
        // util.ajax({
        //     url: "/zh/active/lists",
        //     data:{
        //
        //     },
        //     callback: res => {
        //         if (res.result.status.code == 0) {
        //
        //         }
        //     }
        // });
    }
    getRedeemCode = () => {
        // 获取已获得兑换码列表
        util.ajax({
            url: "/zh/treasure/lists",
            isUser: true,
            isWechatId: true,
            data:{

            },
            callback: res => {
                if (res.result.status.code == 0) {
                    this.setState({
                        redeemCode:  res.result.data
                    })
                }
            }
        });
    };
    getActiveDataAll = () => {
        this.getActiveData(1)
        this.getActiveData(2)
    }
    getActiveData = (type) => {
        // 获取活动进度信息
        util.ajax({
            url: "/zh/treasure/info",
            isUser: true,
            isWechatId: true,
            data:{
                code_type: type
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    if(type === 1){
                        this.setState({
                            activeProcess1:  res.result.data
                        })
                    }
                    if(type === 2){
                        this.setState({
                            activeProcess2:  res.result.data
                        })
                    }
                }
            }
        });
    }

    clickToReport = () => {
        //点击上报
        // util.ajax({
        //     url: "/zh/active/lists",
        //     data:{
        //
        //     },
        //     callback: res => {
        //         if (res.result.status.code == 0) {
        //
        //         }
        //     }
        // });
    }

    JoinToReport = () => {
        this.positionCount(5)
    }

    positionCount = (id) => {
        // position_id:
        // 1,元旦活动_首页banner入口
        // 2,元旦活动_充值页banner入口
        // 3,元旦活动-阅读历史页banner入口
        // 4,元旦活动_前端活动页面
        // 5,元旦活动_前端页面点击投入金币的点击数
        util.ajax({
            url: "/zh/positioncount/push",
            isUser: true,
            isWechatId: true,
            data:{
                position_id:id,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    console.log("打点",id,"成功")
                }
            }
        });
    }

    getUserInfo = () => {
        util.ajax({
            url: "/zh/user/userInfo",
            isUser: true,
            data: {},
            callback: res => {
                if (res && res.result.status.code == 0) {
                    let data = res.result.data
                    this.setState({userInfo: data})
                }
            }
        })
    }

    jumpToPay = () => {
        // 跳转支付
        const type = 5 //后端定义的支付type值\
        let url = window.location.href
        this.props.history.push(`/recharge?treasure=1&weixinurl=${encodeURIComponent(url)}`)
    }
    handleBack = ()=>{
        let from = commonTools.searchPar().from || 1;
        let URL = ['/index','/recharge','/recentlyread'];
        this.props.history.push(URL[from - 1])
    }

    modalOpen = () => {
        var  box= document.getElementById('scrollBox');
        box.style.overflow = "hidden"
        // window.seatscrollTop = document.scrollingElement ? document.scrollingElement.scrollTop : document.body.scrollTop;
        // document.body.style.top = -seatscrollTop + 'px';
        //
        let html = document.getElementsByTagName("body");
        html[0].style.overflow = "hidden"
        // html[0].style.position = "fixed";
        // html[0].style.width = '100%';
    }

    modalClose = () => {
        var  box = document.getElementById('scrollBox');
             box.style.overflow = "auto";
        // box.style.overflow = "hidden"
        let html = document.getElementsByTagName("body");
        html[0].style.overflow = "auto"
        // html[0].style.position = "static";
        // html[0].style.width = 'auto';
        // if (document.scrollingElement) {
        //     document.scrollingElement.scrollTop = seatscrollTop
        // } else {
        //     document.body.scrollTop = seatscrollTop
        // }
    }

    render() {
        return (
            <div>
                <div className="headBack">
                    <span className='headBackBtn' onClick={this.handleBack} style={{color:'#333',float:'left'}}>
                        <img style={{width:'0.2rem',margin:"0.33rem 0.14rem 0"}} src={backImg} alt=""/>
                        <span className='headBackTxt'>
                        </span>
                    </span>
                    <span className='commonHeader_title'>来“鼠”钱，好运到！</span>
                </div>
                <div id="scrollBox" style={{height:'100vh',position:'relative',overflow:'auto'}}>
                    <div className="yuandan_wrap">
                        <div className="head_time_box">
                            <div className="time">
                                <div>活动时间: {this.state.timeRule.notice_start_time}-{this.state.timeRule.notice_end_time}</div>
                                <div>开奖时间: {this.state.timeRule.draw_time}</div>
                            </div>
                            <div className="ruleBtn" onClick={()=>{this.handleOpenRule()}}>
                                活动规则
                            </div>
                        </div>
                        <div onClick={()=>{this.handleCloseRule()}} style={{display: this.state.ruleIsShow ? 'block' : 'none'}} className="activeRuleModalplus"></div>
                        <div style={{display: this.state.ruleIsShow ? 'block' : 'none'}}>
                            <div className="activeRuleContent">
                                <i onClick={()=>{this.handleCloseRule()}} className="ruleClosed"></i>
                                <h4>活动规则</h4>
                                {
                                    this.state.timeRule.rule.map((item,index)=>{
                                        return <div key={index}>
                                            <span className="order">{index + 1}. </span>
                                            <div dangerouslySetInnerHTML={{__html:item.value}}></div>
                                        </div>
                                    })
                                }
                                <div className="ruleFoot">
                                    <div>祝尊敬且亲爱的用户朋友们</div>
                                    <div>2020年万事顺利，大吉大利！！！</div>
                                </div>
                            </div>
                        </div>
                        <div onClick={()=>{this.handleOpenResult()}} className="myCoinResult">我的夺金币结果</div>
                        <div  onClick={()=>{this.handleCloseResult()}} style={{display: this.state.resultIsShowBox ? 'block' : 'none'}} className="activeRuleModal">
                        </div>
                        <div style={{maxHeight: this.state.resultIsShow ? '5rem' : '0px'}} className="activeResultContent">
                            {(this.state.activeProcess1.status === 4 && this.state.activeProcess2.status === 4)&&
                            <div>
                                <i onClick={()=>{this.handleCloseResult()}} className="ruleClosed"></i>
                                <div className="resultTitle"></div>
                                <div className="resultInfoBox">
                                    <div className="resultInfo">
                                        <div>中奖兑换码为 {this.state.winningCheck[0]&&this.state.winningCheck[0].code} 和 {this.state.winningCheck[1]&&this.state.winningCheck[1].code}</div>
                                        <div style={{display: this.state.redeemCode.length ? 'block' : 'none'}}>{this.filterInfo(this.state.winningCheck)}</div>
                                        <div style={{display: this.state.redeemCode.length ? 'block' : 'none'}}>以下为您获得的兑换码：</div>
                                    </div>
                                    <div className="redeemCode">
                                        {
                                            this.state.redeemCode.length ? this.state.redeemCode.map((item,index)=>{
                                                return <div key={index}>{item.code}</div>
                                            }) : <div>您尚未参与活动获得兑换码</div>
                                        }
                                    </div>
                                </div>
                            </div>
                            }
                            {(this.state.activeProcess1.status === 1 && this.state.activeProcess2.status === 1)&&
                            <div>
                                <i onClick={()=>{this.handleCloseResult()}} className="ruleClosed notStartClosed"></i>
                                <div className="resultInfoBox">
                                    <div className="resultTitle notBegin">活动尚在进行中</div>
                                    <div className="resultInfo notStartResultInfo">
                                        <div className="notStartInfo">各位看官请于开奖日期, 前来查看中奖信息 </div>
                                        <div className="notStartInfo">以下为您获得的兑换码：</div>
                                    </div>
                                    <div className="redeemCode">
                                        {
                                            this.state.redeemCode.length ? this.state.redeemCode.map((item,index)=>{
                                                return <div key={index}>{item.code}</div>
                                            }) : <div>您尚未参与活动获得兑换码</div>
                                        }
                                    </div>
                                </div>
                            </div>
                            }
                            {(this.state.activeProcess1.status === 2 && this.state.activeProcess2.status === 2)&&
                            <div>
                                <i onClick={()=>{this.handleCloseResult()}} className="ruleClosed notStartClosed"></i>
                                <div className="resultInfoBox">
                                    <div className="resultTitle notBegin">活动尚未开始</div>
                                    <div className="resultInfo notStartResultInfo">
                                        <div className="notStartInfo">各位看官请于开奖日期, 前来查看中奖信息 </div>
                                    </div>
                                </div>
                            </div>
                            }
                            {
                                (this.state.activeProcess1.status === 3 && this.state.activeProcess2.status === 3)&&
                                <div>
                                    <i onClick={()=>{this.handleCloseResult()}} className="ruleClosed notStartClosed"></i>
                                    <div className="resultInfoBox">
                                        <div className="resultTitle notBegin">活动已结束还没有开奖</div>
                                        <div className="resultInfo notStartResultInfo">
                                            <div className="notStartInfo">各位看官请于开奖日期, 前来查看中奖信息 </div>
                                            <div className="notStartInfo">以下为您获得的兑换码：</div>
                                        </div>
                                        <div className="redeemCode">
                                            {
                                                this.state.redeemCode.length ? this.state.redeemCode.map((item,index)=>{
                                                    return <div key={index}>{item.code}</div>
                                                }) : <div>您尚未参与活动获得兑换码</div>
                                            }
                                        </div>
                                    </div>
                                </div>

                            }
                        </div>

                        {/*规则 时间 背景 底部*/}
                        {/*<Header />*/}
                        {/*活动核心*/}
                        <div style={{position:"absolute",top:"5.2rem",width:"100%"}}>
                            <ActiveCore key={1}
                                        modalOpen={this.modalOpen}
                                        modalClose={this.modalClose}
                                        jumpToPay={this.jumpToPay}
                                        JoinToReport={this.JoinToReport}
                                        getActiveData={this.getActiveDataAll}
                                        activeData={this.state.activeProcess1}
                                        activeId={1}
                                        getUserInfo={this.getUserInfo}
                                        userInfo={this.state.userInfo}/>
                        </div>
                        <div style={{position:"absolute",top:"11.28rem",width:"100%"}}>
                            <ActiveCore key={2}
                                        modalOpen={this.modalOpen}
                                        modalClose={this.modalClose}
                                        jumpToPay={this.jumpToPay}
                                        JoinToReport={this.JoinToReport}
                                        getActiveData={this.getActiveDataAll}
                                        activeData={this.state.activeProcess2}
                                        activeId={2}
                                        getUserInfo={this.getUserInfo}
                                        userInfo={this.state.userInfo}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}